import React from "react";

const SearchForm = ({ dataSearch, onChangeData, onSearch, handleKeyDown }) => (
  <div className="search-new">
    <div className="input-sm-new input-new-18">
      <label htmlFor="sUser" className="font-color-default font-bold">Tên phiếu thu/chi</label>
      <input
        id="sContractName"
        type="text"
        className="form-control input-sm"
        placeholder="Tên phiếu thu/chi"
        onChange={onChangeData("sContractName")}
        onKeyDown={handleKeyDown}
        value={dataSearch.sContractName}
      />
    </div>
    <div className="input-sm-new input-new-18 search-main-new">
      <button
        type="submit"
        className="btn btn-info-new"
        style={{ marginTop: "28px", paddingTop: "7px" }}
        onClick={onSearch}
      >
        <i className="la la-search"></i>
        <span> &nbsp; Tìm kiếm</span>
      </button>
    </div>
  </div>
);

export default SearchForm;